import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

const GetNilDip = () => {
    return axios
        .get(`${URL}/zeroDepreciation`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const PostNilDip = (recData) => {
    return axios
        .post(`${URL}/zeroDepreciation`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        })
        .catch((err) => {
            ToastError(err.response.data.message);
        });
};

const UpdateNilDip = (_id, recData) => {
    return axios
        .put(`${URL}/zeroDepreciation/${_id}`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        })
        .catch((err) => {
            ToastError(err.response.data.message);
        });
};

const DeleteNilDip = (id) => {
    return axios
        .delete(`${URL}/zeroDepreciation/${id}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        })
        .catch((err) => {
            ToastError(err.response.data.message);
        });
};

const FilterNilDip = (recData) => {
    return axios
        .post(`${URL}/zeroDepreciationFilter`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

export {
    GetNilDip,
    PostNilDip,
    UpdateNilDip,
    DeleteNilDip,
    FilterNilDip,
};
